// extracted by mini-css-extract-plugin
module.exports =  {"container":"_59fcf583bb--container--PkSkv","wrapper":"_59fcf583bb--wrapper--kms6q","img":"_59fcf583bb--img--jDgcG","title":"_59fcf583bb--title--oBQpu"};